import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import { ALL_ITEM_JEWELRYBOXES } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";


function RingBoxesPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_JEWELRYBOXES[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Ring Gift Boxes Supplier - Premium Bulk Packaging by Lussopack</title>
        <meta name="description" content="Shop ring boxes in bulk. Your trusted supplier of wholesale ring boxes. Discover premium designs and quality packaging for your brand. Ship worldwide." />
        <meta name="keywords" content="Luxury Ring" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/ring-boxes" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Luxury Ring Gift Boxes"}
        textSubHeader={"Showcase your rings with our custom luxury ring boxes. Designed for elegance and durability, our solutions highlight your pieces beautifully while providing superior protection."}
      />        
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default RingBoxesPage;
